import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// Link
import { Link } from "react-router-dom";

// @material-ui/icons
import ColorLens from "@material-ui/icons/ColorLens";
import Group from "@material-ui/icons/Group";
import ImportantDevices from "@material-ui/icons/ImportantDevices";
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";
import Favorite from "@material-ui/icons/Favorite";
import Work from "@material-ui/icons/Work";
import Gamepad from "@material-ui/icons/Gamepad";
import Search from "@material-ui/icons/Search";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import SimpleInfoArea from "components/SimpleInfoArea/SimpleInfoArea.jsx";
import Button from "components/CustomButtons/Button.jsx";
import domainStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/domainStyle.jsx";
import InfoDomainArea from "components/InfoDomainArea/InfoDomainArea.jsx";
// Image
import Design from "assets/img/domains/Design.svg";
import Experience from "assets/img/domains/Experience.svg";
import Facilitate from "assets/img/domains/Facilitate.svg";
import Industry from "assets/img/domains/Industry.svg";
import Innovation from "assets/img/domains/Innovation.svg";
import Optimise from "assets/img/domains/Optimise.svg";
import Assessment from "assets/img/domains/Assessment.svg";

class DomainsSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <h2 className={classes.title}>TEN Capability Framework</h2>
            <h5 className={classes.description}>
              The TEN Capability Framework is a framework which guides and
              supports our teaching and academic support staff in the delivery
              of high-quality student learning experiences. This framework also
              offers a means to discuss, benchmark and provide evidence for
              performance, progress and impact as appropriate across the
              diversity of learning and teaching contexts at Navitas.
            </h5>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <h4 className={classes.title}>Principles of the TEN Capability Framework</h4>
              <h5 className={classes.description}>
                The following principles underpin the TEN Capability Framework:
              </h5>
            </GridItem>
          </GridContainer>
        </div>
        <div>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <SimpleInfoArea
                title="Inclusivity"
                description="Enabling fair and equitable access to learning and teaching programs and services."
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <SimpleInfoArea
                title="Flexibility"
                description="Creating structures and systems that are agile and responsive to the evolving needs of capability development."
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <SimpleInfoArea
                title="Collaboration"
                description="Working in partnership with all stakeholders to engender shared ownership and responsibility for developing teaching capability."
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <SimpleInfoArea
                title="Interconnectivity"
                description="Connecting people, disciplines and activities locally, regionally and internationally to harness collective wisdom and create new solutions to learning and teaching challenges."
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <SimpleInfoArea
                title="Scholarly approach"
                description="Driving learning and teaching practices through reflection on and engagement with industry, academics and the scholarship of learning and teaching."
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>
        <div>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <h5 className={classes.description}>
                Acknowledging the various teaching and academic support roles at
                Navitas, the framework offers definitions for the specific
                knowledge, skills and principles which contribute to ‘teaching
                excellence’ across seven interdependent domains. Learn more
                about the domains below:
              </h5>
            </GridItem>
          </GridContainer>
        </div>
        <div>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={3}>
              <InfoDomainArea
                title="Designing Learning and Teaching"
                description="Designing curriculum including strategies for organising content, learning pathways and activities that maximise retention and student success"
                icon={ColorLens}
                iconColor="design"
                vertical
                image={Design}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <InfoDomainArea
                title="Facilitating and Delivering Learning and Teaching"
                description="Teaching quality in the design, delivery and evaluation including pedagogical approaches and cohort analysis"
                icon={Group}
                iconColor="facilitate"
                vertical
                image={Facilitate}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <InfoDomainArea
                title="Transforming Assessment"
                description="Transforming assessment to maximise student learning from both the process and products of assessment"
                icon={AssignmentTurnedIn}
                iconColor="assessment"
                vertical
                image={Assessment}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <InfoDomainArea
                title="Optimising Digital Technologies for Learning and Teaching"
                description="Using digital content, tools and technologies to improve student outcomes and increase teacher impact, including with productivity and collaboration systems"
                icon={ImportantDevices}
                iconColor="optimise"
                vertical
                image={Optimise}
              />
            </GridItem>
          </GridContainer>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={3}>
              <InfoDomainArea
                title="Transforming the Broader Student Experience"
                description="A culture that promotes the equitable participation, retention and progression of all students to, through and beyond the learning/classroom"
                icon={Favorite}
                iconColor="experience"
                vertical
                image={Experience}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <InfoDomainArea
                title="Industry and Academic Collaboration & Currency"
                description="Ongoing engagement in the profession that ensures currency of knowledge and practice"
                icon={Work}
                iconColor="industry"
                vertical
                image={Industry}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <InfoDomainArea
                title="Innovating in Learning and Teaching"
                description="Changing the way we teach and our students learn to improve student outcomes"
                icon={Gamepad}
                iconColor="innovation"
                vertical
                image={Innovation}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem>
              <Link to={"/catalogue"}>
                <Button color="primary">
                  <Search />
                  Check out PD offering
                </Button>
              </Link>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(domainStyle)(DomainsSection);
